import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { getLevelLinesListFromItemList } from '../utils';
import { EditorBookingItem } from '../editor-booking-item/editor-booking-item.model';
import {CdkDragDrop} from '@angular/cdk/drag-drop';
import { EditorBookingItemTreeStore } from '../editor-booking-item-tree/editor-booking-item-tree.store';

@Component({
    selector: 'eas-editor-booking-item-option-list',
    templateUrl: './editor-booking-item-option-list.component.html',
    styleUrls: ['./editor-booking-item-option-list.component.css'],
    standalone: false
})
export class EditorBookingItemOptionListComponent implements OnChanges, OnInit {
  @Input() itemOptions: EditorBookingItem[];

  levelLinesList: boolean[][];

  constructor(
        private itemTreeStore: EditorBookingItemTreeStore,
  ) {

  }

  ngOnInit() {

  }

  ngOnChanges(_changes: SimpleChanges) {
    this.levelLinesList = getLevelLinesListFromItemList(this.itemOptions);
  }

  public drop(event: CdkDragDrop<string[]>, id: string) {
    let indexRange: number = event.previousIndex - event.currentIndex
    for (let i = 0; i < Math.abs(indexRange); i++) {
      if (indexRange > 0)
        this.itemTreeStore.moveItemUp(id);
      else if (indexRange < 0)
        this.itemTreeStore.moveItemDown(id);
    }
  }

}
